import { jsx as _jsx } from "react/jsx-runtime";
import { Stepper } from "@mui/material";
import { forwardRef } from "react";
export const UiStepper = forwardRef((props, ref) => (_jsx(Stepper, Object.assign({ ref: ref }, props))));
//# sourceMappingURL=ui_stepper.js.map